import { render, staticRenderFns } from "./EditOaSettings.vue?vue&type=template&id=49eeb04b&"
import script from "./EditOaSettings.vue?vue&type=script&lang=js&"
export * from "./EditOaSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditOaSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports